import React, { useState } from "react";
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";
import DisplayImage from "../DisplayImage";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import "../../css/Admin-PhotoGallery/UploadPhotoGallery.css";
import Spinner from "../Spinner";

const UploadPhotoGallery = ({ onClose, fetchData }) => {
  const [loading, setLoading] = useState(false);
  const [uploadPhotoGallery, setUploadPhotoGallery] = useState(0);
  const [data, setData] = useState({
    photoGalleryName:"",
    photoGalleryDescription:"",
    photoType:"desktop",
    PhotoGalleryImage: [],
  });
  const [fullScreenImage, setFullScreenImage] = useState("");
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({
      ...pre,
      [name]: value,
    }));
  };

  async function handleUploadLogo(e) {
    setLoading(true);
    const image = e.target.files[0];
    return new Promise((resolve, reject) => {
      const storage = getStorage();
      const filename = `PhotoGallery-${image.name}-${uuidv4()}`;
      const storageRef = ref(storage, filename);
      const uploadTask = uploadBytesResumable(storageRef, image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setUploadPhotoGallery(progress);
          console.log("Upload is " + progress + "% done");
        },
        (error) => {
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
            //console.log(downloadURL);
            setData((prev) => ({
              ...prev,
              PhotoGalleryImage: [...(prev.PhotoGalleryImage || []), downloadURL],
            }));
            setLoading(false);
          });
        }
      );
      setLoading(false);
    });
  }


  const handleDeleteLogo = (index) => {
    const newLogos = [...data.PhotoGalleryImage];
    newLogos.splice(index, 1);
    setData((pre) => ({
      ...pre,
      PhotoGalleryImage: newLogos,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await addDoc(collection(db, "photoGallery"), data);
    setLoading(false);
    toast.success("Image Added");
    fetchData();
    onClose();
  };
  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="overlay">
      <div className="edit-product-modal">
        <div className="modal-header">
          <h2 className="title">Add Images</h2>
          <div className="close-icon" onClick={onClose}>
            <CgClose />
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label htmlFor="photoGalleryName">Photo Name :</label>
          <input
            type="text"
            id="photoGalleryName"
            placeholder="Enter Photo name"
            value={data.photoGalleryName}
            name="photoGalleryName"
            onChange={handleOnChange}
            className="input"
            required
          />
          <label htmlFor="photoGalleryDescription">Description :</label>
          <input
            type="text"
            id="photoGalleryDescription"
            placeholder="Enter Description"
            value={data.photoGalleryDescription}
            name="photoGalleryDescription"
            onChange={handleOnChange}
            className="input"
            min={0}
            max={100}
            required
          />
          <label htmlFor="photoType">Select Photo Type:</label> 
          <select
            required
            value={data.photoType}
            name="photoType"
            onChange={handleOnChange}
            className="input"
          >

            <option value="desktop" key="desktop">Desktop</option>
            <option value="mobile" key="mobile">Mobile</option>
          </select>

          <label htmlFor="PhotoGalleryImage" className="label">
            Images :
          </label>
          <label htmlFor="PhotoGalleryImage">
            <div className="upload-container">
              <div className="upload-content">
                <span className="upload-icon">
                  <FaCloudUploadAlt />
                </span>
                <p className="upload-text">Upload Images</p>
                <input
                  type="file"
                  id="PhotoGalleryImage"
                  className="hidden"
                  onChange={handleUploadLogo}
                />
              </div>
            </div>
          </label>
          {uploadPhotoGallery > 0 && uploadPhotoGallery < 100 && (
            <label style={{color:'blue',textAlign:'center'}}>{`Upload is ${uploadPhotoGallery}% done`}</label>
          )}

          <div>
            {data.PhotoGalleryImage.length > 0 ? (
              <div className="image-preview">
                {data.PhotoGalleryImage.map((el, index) => (
                  <div className="image-container" key={index}>
                    <img
                      src={el}
                      alt={el}
                      className="image"
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className="delete-icon"
                      onClick={() => handleDeleteLogo(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="error-text">*Please Upload Images</p>
            )}
          </div>

          
          
          <button className="submit-button" disabled={loading}>
            Add Images
          </button>
        </form>
      </div>
      {openFullScreenImage && (
        <DisplayImage
          onClose={() => setOpenFullScreenImage(false)}
          imageUrl={fullScreenImage}
        />
      )}
    </div>
  );
};

export default UploadPhotoGallery;
